const mergeStyles = (props = {}, ...conditionals) => {
    const { style } = props;
    const propStyle = style
        ? Array.isArray(style)
            ? style
            : [style]
        : [];
    const mergedStyles = conditionals.reduce((acc, style) => {
        return Array.isArray(style)
            ? style[1] ? [...acc, style[0]] : acc
            : [...acc, style];
    }, []);
    return [mergedStyles, ...propStyle];
};
export default mergeStyles;
//# sourceMappingURL=mergeStyles.js.map